"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const SectionHeader = ({ section }) => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignItemsCenter] },
    react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack] }, section)),
    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.blackBackgroundColor, styles_1.default.marginLeftFive, { height: 1 }] })));
exports.default = SectionHeader;
